import withList from '../../with-list/main';
import { selectors, actions } from './';
import table from './table-initial-data';

export default withList(selectors, actions, table, {
	link: '/blog/article-images/editor',
	text: 'Create article image'
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article-image/list/main.js